'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var toMomentObject = {};

exports.__exports = toMomentObject;
